<template>
  <div>
    <date-picker auto-submit accepted="bottom-left" @change="search" v-model="input" input-class="ant-input"/>
  </div>
</template>

<script>
export default {
  name: 'DateXTableFilter',
  props: ['value'],
  data() {
    return {
      input: undefined
    }
  },
  methods: {
    search() {
      this.$emit('input', this.input)
    },
  },
  mounted() {
    this.input = this.value
  }
}
</script>
<style>
.vpd-input-group label{
  border-radius: 0 4px 4px 0;
}
</style>
